// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"26258c91","453":"398ba004","455":"a4ea56b4","977":"082ed684"}[chunkId] + ".chunk.js";
};